export default __webpack_public_path__ + "static/graphik-medium-web-a7cb7fdc7388750062f7362d61436720.woff2";